import {LeagueStatus} from '../../apis/volume_league/list'

// 상태 메타 (라벨 / 셀렉트 색상 / 상태 원 색상 / live 여부)
//  - draft 회색 · active 초록(live) · paused 밝은 빨강 · ended 진한 빨강
export const STATUS_META: {[k in LeagueStatus]: {label: string; select: string; dot: string; live: boolean}} = {
    draft: {label: '준비 중', select: 'bg-line02 text-font03', dot: 'bg-font03', live: false},
    active: {label: '진행 중', select: 'bg-tag_green_light text-font_green', dot: 'bg-primary', live: true},
    paused: {label: '일시중지', select: 'bg-red-50 text-red-400', dot: 'bg-red-400', live: false},
    ended: {label: '종료', select: 'bg-tag_red_light text-font_red', dot: 'bg-font_red', live: false},
}
export const STATUS_ORDER: LeagueStatus[] = ['draft', 'active', 'paused', 'ended']

// 상시 순위표 기간 세트 프리셋 (24H=1일, 그 외 N일). fixed = 항상 포함(개별 해제 불가)
export const WINDOW_PRESETS: {wd: number; label: string; fixed: boolean}[] = [
    {wd: 1, label: '24H', fixed: true},
    {wd: 7, label: '7D', fixed: true},
    {wd: 30, label: '30D', fixed: true},
    {wd: 90, label: '90D', fixed: false},
    {wd: 180, label: '180D', fixed: false},
]
export const FIXED_WINDOWS = WINDOW_PRESETS.filter(p => p.fixed).map(p => p.wd) // [1,7,30]

export const REFRESH_OPTIONS = [30, 60, 90, 300, 600]

// markets scope 에서 서버가 받는 (거래소, 종류) 조합 — 백엔드 entity/volumeleague_market.go 와 동일.
// 여기 없는 조합은 서버가 "unsupported market" 으로 거절한다 (주문 저장 형태가 검증된 시장만 집계).
export const MARKET_SUPPORT: {[exchange: string]: Array<'spot' | 'futures'>} = {
    bithumb: ['spot'],
    binance: ['spot', 'futures'],
    bybit: ['spot', 'futures'],
}

// markets 입력 예시 (JSON)
export const MARKETS_EXAMPLE = `[
  {"exchange": "bithumb", "type": "spot", "symbol": "BILL", "quote": "KRW"},
  {"exchange": "binance", "type": "futures", "symbol": "BILLUSDT"}
]`
